import { PaintedScene } from '../PaintedScene';

export const COTTAGE_CREST_PHASER_KEY = 'CottageCrestScene' as const;
export const COTTAGE_CREST_MANIFEST_KEY = 's-001-cottage-crest' as const;

export class CottageCrestScene extends PaintedScene {
  constructor() {
    super(COTTAGE_CREST_PHASER_KEY, COTTAGE_CREST_MANIFEST_KEY);
  }
}
